/* import __COLOCATED_TEMPLATE__ from './textarea.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import clsx from 'clsx';

/** @type {string} */
const CLASS_NAME = 'GLM-textarea';
const CLASS_NAME_CAPTION = `${CLASS_NAME}--caption`;
const CLASS_NAME_CHAR_COUNTER = `${CLASS_NAME}--char-counter`;
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;
const CLASS_NAME_ERROR = `${CLASS_NAME}--error`;
const CLASS_NAME_FOCUSED = `${CLASS_NAME}--focused`;

/** @type {object} */
const THEMES = {
  BLACK: 'black',
  WHITE: 'white',
};

const THEME_TO_CLASS_MAP = Object.keys(THEMES).reduce((accum, themeKey) => {
  const theme = THEMES[themeKey];
  accum[theme] = `${CLASS_NAME}--theme-${theme}`;
  return accum;
}, {});

/** @class */
class GlmTextarea extends Component {
  @tracked hasFocus = false;

  get classNames() {
    const hasCaption = Boolean(this.args.caption);
    const hasCharCounter = Boolean(this.args.maxlength);

    return clsx(
      CLASS_NAME,
      hasCaption && CLASS_NAME_CAPTION,
      hasCharCounter && CLASS_NAME_CHAR_COUNTER,
      this.args.disabled && CLASS_NAME_DISABLED,
      this.hasError && CLASS_NAME_ERROR,
      this.hasFocus && CLASS_NAME_FOCUSED,
      this.theme,
      this.args.class,
    )
  }

  get className() {
    return CLASS_NAME;
  }

  get hasError() {
    return Boolean(this.args.error);
  }

  get characterCount() {
    return this.args.value?.length ?? 0;
  }

  get theme() {
    const { theme } = this.args;
    return THEME_TO_CLASS_MAP[theme || THEMES.BLACK];
  }

  /**
   *
   */
  @action
  handleFocus() {
    this.hasFocus = true;

    this.args.onfocus?.();
  }

  /**
   *
   */
  @action
  handleBlur() {
    this.hasFocus = false;

    this.args.onblur?.();
  }

  /**
   * @param {InputEvent} e
   */
  @action
  handleInput({ target }) {
    this.args.oninput?.(target.value);
  }

  /**
   * @param {KeyboardEvent} e
   */
  @action
  handleKeyDown(e) {
    this.args.onkeydown?.(e);
  }

  /**
   * @param {MouseEvent} e
   */
  @action
  handleClick(e) {
    this.args.onclick?.(e);
  }
}

export default GlmTextarea;
